import { render, staticRenderFns } from "./StudentSocialItem.vue?vue&type=template&id=a3ff8c42&scoped=true&"
import script from "./StudentSocialItem.vue?vue&type=script&lang=js&"
export * from "./StudentSocialItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentSocialItem.vue?vue&type=style&index=0&id=a3ff8c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ff8c42",
  null
  
)

export default component.exports